package com.ilussobsa.views

import com.ilussobsa.*
import com.ilussobsa.Strings
import com.ilussobsa.Vehicle
import com.ilussobsa.sdk.currentSession
import com.ilussobsa.sdk.currentUserSession
import com.ilussobsa.sdk.currentUserSessionNullable
import com.ilussobsa.utils.*
import com.lightningkite.UUID
import com.lightningkite.kiteui.*
import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.navigation.pageNavigator
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.l2.children
import com.lightningkite.kiteui.views.l2.field
import com.lightningkite.kiteui.views.l2.icon
import com.lightningkite.lightningdb.*
import com.lightningkite.lightningserver.files.*
import com.lightningkite.now
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*
import com.lightningkite.serialization.*
import kotlin.collections.plus
import kotlin.js.JsName
import kotlin.jvm.JvmName
import kotlin.math.round
import kotlinx.serialization.Serializable

@Routable("edit-vehicle/{vehicleId}")
class EditVehicleScreen(val vehicleId: UUID) : Page {
    @QueryParameter
    val flowMode = Signal(true)

    companion object {
        val log = ConsoleRoot.tag("EditVehicleScreen")
    }

    @Serializable
    enum class Tab(
        val title: String,
        val render: ViewWriter.(vehicle: Signal<Vehicle>, proceed: suspend () -> Unit) -> Unit,
        val fields: List<FieldWithValidator<*>>
    ) {
        Images(
            Strings.images, render = { vehicle, proceed ->

                expanding - recyclerView {
                    ::columns { round(AppState.windowInfo().width.px / 20.rem.px).toInt() }

                    val medias = MutableRemember { (vehicle().media + null).withIndex().toList() }
                    reactiveSuspending {
                        vehicle set vehicle.awaitOnce().copy(media = medias().mapNotNull { it.value }, photos = medias().filter {
                            it.value?.type?.contains("image") == true
                        }.mapNotNull {
                            it.value?.file?.let { file -> VehiclePhoto(file) }
                        })
                    }
                    fun <T> List<IndexedValue<T>>.rearrange(block: MutableList<T>.() -> Unit): List<IndexedValue<T>> {
                        val mutable = map { it.value }.toMutableList()
                        block(mutable)
                        return mutable.withIndex().toList()
                    }
                    fun <T> List<IndexedValue<T>>.swap(indexA: Int, indexB: Int) =
                        List(size) { index ->
                            if (index == indexA) this[indexB].value
                            else if (index == indexB) this[indexA].value
                            else this[index].value
                        }.withIndex().toList()

                    children(medias, id = { it.value?.file?.location ?: it.index.toString() }) { media ->
                        card - compact - col {
                            button {
                                sizeConstraints(width = 20.rem, height = 12.rem) - frame {
                                    ::shown { media().value?.file != null }
                                    image {
                                        ::scaleType {
                                            if (media().value?.type?.contains("video") == true) ImageScaleType.Fit else ImageScaleType.Crop
                                        }

                                        this.description = ""

                                        ::source {
                                            media().value?.let {
                                                if (it.type.contains("video")) {
                                                    Icon.roundPlay.toImageSource(Color.gray)
                                                } else {
                                                    it.file.toImage()
                                                }
                                            }
                                        }

                                    }
                                }

                                sizeConstraints(width = 20.rem, height = 12.rem) - frame {
                                    ::shown { media().value?.file == null }

                                    centered- col {
                                        centered - icon(Icon.add, "")
                                        centered - text(Strings.add)
                                    }
                                }
                                onClick {
                                    val photoWhenClicked = media()
//                                        log.info("Requesting capture")
                                    val mediaFiles =
                                        ExternalServices.requestFiles(listOf("image/jpeg", "image/png", "video/*"))
                                    val session = currentUserSessionNullable.await() ?: return@onClick
                                    if (mediaFiles.isEmpty()) return@onClick
//                                        log.info("Uploading...")
                                    val uploads = mediaFiles.map { file ->
                                        file to session.api.uploadFileForRequest().upload(RequestBodyFile(file))
                                    }
//                                        log.info("Uploaded")
                                    medias set medias().rearrange {
                                        tempImagePointers[uploads.first().second] = ImageLocal(uploads.first().first)
                                        set(
                                            photoWhenClicked.index,
                                            VehicleMedia(uploads.first().second, uploads.first().first.mimeType())
                                        )
                                        if (uploads.size > 1) {
                                            addAll(
                                                photoWhenClicked.index + 1,
                                                uploads.subList(1, uploads.size).map { upload ->
                                                    if (upload.first.mimeType().contains("image")) {
                                                        tempImagePointers[upload.second] = ImageLocal(upload.first)
                                                    }
                                                    VehicleMedia(upload.second, upload.first.mimeType())
                                                })
                                        }
                                        if (last() != null) add(null)
                                    }
                                }
                            }
                            compact - frame {
//                                    atTopStart - button {
//                                        ::shown {
//                                            media().value is VehicleMedia.Video
//                                        }
//                                        icon(Icon.videoSettings, "")
//                                        onClick {
//                                            println("edit thumbnail")
//                                        }
//                                    }
                                compact - centered - row {
                                    ::shown { media().value != null }
                                    button {
                                        ::enabled { media().index > 0 }
                                        icon(Icon.chevronLeft, "")
                                        onClick {
                                            val index = media().index
                                            medias set medias().swap(index, index - 1)
                                        }
                                    }
                                    button {
                                        ::enabled { media().index < (medias().size - 2) }
                                        icon(Icon.chevronRight, "")
                                        onClick {
                                            val index = media().index
                                            medias set medias().swap(index, index + 1)
                                        }
                                    }
                                }
                                atTopEnd - button {
                                    ::shown { media().value != null }
                                    icon(Icon.delete, "")
                                    onClick {
                                        val index = media().index
                                        medias set medias().rearrange {
                                            removeAt(index)
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

            }, fields = listOf(
                Vehicle_media.required(),
                Vehicle_photos.required()
            )
        ),
        BasicInformation(
            Strings.basics, render = { it, proceed ->
                card - col {
                    label {
                        content = Strings.vin
                        fieldTheme - textField {
                            keyboardHints = KeyboardHints.id
                            content bind it.prop(Vehicle.path.vin)
                        }
                    }
                    rowCollapsingToColumn(45.rem) {
                        expanding - rowCollapsingToColumn(30.rem) {
                            weight(2f) - label {
                                content = Strings.year
                                fieldTheme - textField {
                                    keyboardHints = KeyboardHints.integer
                                    content bind it.prop(Vehicle.path.year).lens(
                                        get = { it?.toString() ?: "" },
                                        modify = { o, it -> it.toShortOrNull() ?: o }
                                    )
                                }
                            }
                            weight(3f) - label {
                                content = Strings.make
                                fieldTheme - textField {
                                    keyboardHints = KeyboardHints.title
                                    content bind it.prop(Vehicle.path.make).nullToBlank()
                                }
                            }
                        }
                        expanding - rowCollapsingToColumn(30.rem) {
                            weight(3f) - label {
                                content = Strings.model
                                fieldTheme - textField {
                                    keyboardHints = KeyboardHints.title
                                    content bind it.prop(Vehicle.path.model).nullToBlank()
                                }
                            }
                            weight(3f) - label {
                                content = Strings.trim2
                                fieldTheme - textField {
                                    keyboardHints = KeyboardHints.title
                                    content bind it.prop(Vehicle.path.trim).nullToBlank()
                                }
                            }
                        }
                    }
                    rowCollapsingToColumn(30.rem) {
                        weight(1f) - label {
                            content = Strings.exteriorColor
                            fieldTheme - textField {
                                keyboardHints = KeyboardHints.title
                                content bind it.prop(Vehicle.path.exteriorColor).nullToBlank()
                            }
                        }
                        weight(1f) - label {
                            content = Strings.interiorColor
                            fieldTheme - textField {
                                keyboardHints = KeyboardHints.title
                                content bind it.prop(Vehicle.path.interiorColor).nullToBlank()
                            }
                        }
                    }
                    rowCollapsingToColumn(30.rem) {
                        weight(3f) - label {
                            content = Strings.fuel2
                            fieldTheme - select {
                                bind(
                                    it.prop(Vehicle.path.fuelType),
                                    Constant(listOf(null) + FuelType.values().toList()),
                                    { it?.name ?: Strings.selectOne })
                            }
                        }
                        weight(3f) - label {
                            content = Strings.transmission1
                            fieldTheme - select {
                                bind(
                                    it.prop(Vehicle.path.transmission),
                                    Constant(listOf(null) + Transmission.values().toList()),
                                    { it?.name ?: Strings.selectOne })
                            }
                        }
                    }
                }
            }, fields = listOf(
                Vehicle_vin.required(),
                Vehicle_year.required(),
                Vehicle_make.required(),
                Vehicle_model.required(),
                Vehicle_trim.optional(),
                Vehicle_transmission.required(),
                Vehicle_fuelType.required(),
                Vehicle_interiorColor.required(),
                Vehicle_exteriorColor.required(),
            )
        ),
        Odometer(
            Strings.odometer, render = { it, proceed ->
                card - col {
                    centered - sizeConstraints(width = 25.rem) - label {
                        content = Strings.odometer
                        fieldTheme - row {
                            expanding - numberField {
                                content bind it.prop(Vehicle.path.odometer).asDouble()
                            }
                            text("mi")
                        }
                    }
                }
            }, fields = listOf(
                Vehicle_odometer.required(),
            )
        ),
        Condition(
            Strings.condition, render = { it, proceed ->
                card - col {
                    h3 { content = Strings.keys1 }
                    row {
                        for (value in KeyCount.values()) {
                            expanding - important - radioToggleButton {
                                centered - text("${value.text} keys")
                                checked bind it.prop(Vehicle.path.keys).equalTo(value)
                            }
                        }
                    }
                    h3 { content = Strings.tireCondition1 }
                    row {
                        for (value in TireStatus.values()) {
                            expanding - important - radioToggleButton {
                                col {
                                    centered - text(value.name)
                                    centered - text(value.rangeText)
                                }
                                checked bind it.prop(Vehicle.path.tires).equalTo(value)
                            }
                        }
                    }
                    h3 { content = Strings.activeWarranty }
                    row {
                        for (value in listOf(true, false)) {
                            expanding - important - radioToggleButton {
                                col {
                                    centered - text(Strings.yesOrNo(value))
                                }
                                checked bind it.prop(Vehicle.path.activeWarranty).equalTo(value)
                            }
                        }
                    }
                    h3 { content = Strings.attachments }
                    text { content = Strings.recommendedUploads }
                    col {
                        forEachUpdating(remember {
                            (it().attachments?.indices?.toList() ?: listOf())
                        }) { index ->
                            row {
                                important - button {
                                    centered - icon {
                                        source = Icon.download
                                    }
                                    onClick {
                                        val index = index()
                                        val session = currentUserSessionNullable.await() ?: return@onClick
                                        ExternalServices.requestFile(
                                            listOf(
                                                "image/png",
                                                "image/jpeg",
                                                "application/pdf"
                                            )
                                        )?.let {
                                            session.api.uploadFileForRequest().upload(RequestBodyFile(it))
                                        }?.let { file ->
                                            it.modify {
                                                it.copy(
                                                    attachments = it.attachments?.toMutableList()?.apply {
                                                        this[index] = this[index].copy(file = file)
                                                    } ?: listOf()
                                                )
                                            }
                                        }
                                    }
                                }

                                expanding - fieldTheme - textField {
                                    hint = "Label"
                                    content bind remember {
                                        it().attachments?.getOrNull(
                                            index()
                                        )?.label ?: ""
                                    }
                                        .withWrite { value ->
                                            val index = index()
                                            it.modify {
                                                it.copy(
                                                    attachments = it.attachments.toMutableList().apply {
                                                        this[index] = this[index].copy(label = value)
                                                    }
                                                )
                                            }
                                        }
                                }

                                danger - button {
                                    gravity(
                                        Align.Center,
                                        Align.Center
                                    ) - icon(Icon.delete, Strings.removeEntry)
                                    onClick {
                                        it.modify {
                                            it.copy(attachments = it.attachments.toMutableList().apply {
                                                removeAt(index())
                                            })
                                        }
                                    }
                                }
                            }
                        }
                    }
                    button {
                        centered - row {
                            centered - icon(Icon.add, "")
                            centered - text {
                                ::content {
                                    if (it().attachments.isEmpty()) Strings.add else Strings.addAnother
                                }
                            }
                        }
                        onClick {
                            val session = currentUserSessionNullable.await() ?: return@onClick
                            ExternalServices.requestFiles(listOf("image/png", "image/jpeg", "application/pdf")).map {
                                it.fileName() to session.api.uploadFileForRequest().upload(RequestBodyFile(it))
                            }.takeIf { it.isNotEmpty() }?.let { files ->
                                it.modify {
                                    it.copy(
                                        attachments = it.attachments + files.map { Attachment(it.first, it.second) }
                                    )
                                }
                            }
                        }
                    }
                }

            }, fields = listOf(
                Vehicle_tires.required(),
                Vehicle_keys.required(),
                Vehicle_activeWarranty.required(),
                Vehicle_attachments.optional(),
            )
        ),
        Issues(
            Strings.announcements, render = { vehicle, proceed ->
                card - col {
                    fun extraInfoField(name: String, icon: Icon, property: DataClassPath<Vehicle, ExtraInfo?>) {
                        val selected = remember {
                            vehicle.awaitNotNull().let { property.get(it) } != null
                        }.withWrite {
                            if (it) {
                                vehicle.modify { property.set(it, ExtraInfo()) }
                            } else {
                                vehicle.modify { property.set(it, null) }
                            }
                        }
                        col {
                            row {
                                fieldTheme - checkbox {
                                    checked bind selected
                                }
                                icon {
                                    source = icon
                                }
                                expanding - h3(name)
                            }
                            card - col {
                                ::shown { selected() }
                                label {
                                    content = Strings.explanation
                                    sizeConstraints(minHeight = 6.rem) - fieldTheme - textArea {
                                        keyboardHints = KeyboardHints.paragraph
                                        hint = Strings.explainWhatYouKnowAboutThisHere
                                        content bind vehicle.prop(property.notNull.description).nullToBlank()
                                    }
                                }
                            }
                        }
                    }

                    extraInfoField(Strings.priorAccident, Icon.priorAccident, Vehicle.path.priorAccident)
                    extraInfoField(Strings.paintWork, Icon.paintwork, Vehicle.path.paintwork)
                    extraInfoField(Strings.warningLights, Icon.warning, Vehicle.path.warningLights)
                    extraInfoField(Strings.towRequired, Icon.towing, Vehicle.path.towRequired)
                    extraInfoField(Strings.nonRunner, Icon.close, Vehicle.path.nonRunner)
                    extraInfoField(Strings.structuralDamage, Icon.damage, Vehicle.path.structuralDamage)
                    extraInfoField(Strings.airConditioningIssue, Icon.acIssues, Vehicle.path.airConditioningIssue)
                    extraInfoField(Strings.transmissionIssue, Icon.close, Vehicle.path.transmissionIssue)
                    extraInfoField(Strings.odometerIssue, Icon.speedometer, Vehicle.path.odometerIssue)
                    extraInfoField(Strings.canadian, Icon.canada, Vehicle.path.canadian)

                    h2(Strings.titleBranding)
                    extraInfoField(Strings.salvage, Icon.recycling, Vehicle.path.salvage)
                    extraInfoField(Strings.lemonLaw, Icon.lemon, Vehicle.path.lemonLaw)
                    extraInfoField(Strings.flood, Icon.waterDrop, Vehicle.path.flood)
                    extraInfoField(Strings.stolenRecovery, Icon.money, Vehicle.path.stolenOrRecovery)
                    extraInfoField(Strings.rentalTaxi, Icon.taxi, Vehicle.path.rentalOrTaxi)
                    extraInfoField(Strings.trueMileageUnknown, Icon.close, Vehicle.path.trueMileageUnknown)

                    space(2.0)
                    row {
                        fieldTheme - checkbox {
                            checked bind remember { vehicle().considerationsFilled }
                                .withWrite { v -> vehicle.modify { it.copy(considerationsFilled = v) } }
                        }
                        centered - expanding - text(Strings.informationIsAccurate)
                    }
                }
            }, fields = listOf(
                Vehicle_considerationsFilled.required(),
                Vehicle_priorAccident.optional(),
                Vehicle_paintwork.optional(),
                Vehicle_warningLights.optional(),
                Vehicle_towRequired.optional(),
                Vehicle_nonRunner.optional(),
                Vehicle_structuralDamage.optional(),
                Vehicle_airConditioningIssue.optional(),
                Vehicle_transmissionIssue.optional(),
                Vehicle_odometerIssue.optional(),
                Vehicle_canadian.optional(),
                Vehicle_salvage.optional(),
                Vehicle_lemonLaw.optional(),
                Vehicle_flood.optional(),
                Vehicle_stolenOrRecovery.optional(),
                Vehicle_rentalOrTaxi.optional(),
                Vehicle_trueMileageUnknown.optional(),
            )
        ),
        Location(
            Strings.location, render = { it, proceed ->
                fun ViewWriter.address(address: MutableReactive<UsAddress>) {
                    col {
                        field(Strings.streetAddress) {
                            textInput { content bind address.lensPath { it.street }.nullToBlank() }
                        }

                        rowCollapsingToColumn(50.rem) {
                            weight(1f) - field(Strings.city) {
                                textInput { content bind address.lensPath { it.city }.nullToBlank() }
                            }
                            weight(1f) - field(Strings.state) {
                                select {
                                    bind(
                                        address.lensPath { it.state },
                                        Constant(listOf(null) + UsState.entries.toList())
                                    ) { it?.text ?: "Pick one" }
                                }
                            }
                            weight(1f) - field(Strings.zip) {
                                textInput { content bind address.lensPath { it.zip }.nullToBlank() }
                            }
                        }
                    }
                }

                val locations = listOf(
                    UsAddress("121 Commerce Rd", "Boynton Beach", UsState.FL, "33426"),
                    UsAddress("1561 MacArthur Blvd", "Costa Mesa", UsState.CA, "92626")
                )

                card - col {
                    for (value in locations) {
                        important - radioToggleButton {
                            text(value.toString())
                            checked bind it.lensPath { it.location }.equalTo(value)
                        }
                    }
                    space()
                    address(it.lensPath { it.location })
                }
            }, fields = listOf(
                FieldWithValidator(Vehicle_location) {
                    if (it.street == null) EditStatus.Empty
                    if (it.city == null) EditStatus.Empty
                    if (it.state == null) EditStatus.Empty
                    if (it.zip == null) EditStatus.Empty
                    else EditStatus.Complete
                }
            )
        ),
        Description(
            Strings.description, render = { vehicle, proceed ->
                card - col {
                    text(Strings.vehicleDescriptionPrompt)
                    sizeConstraints(minHeight = 10.rem) - fieldTheme - textArea {
                        keyboardHints = KeyboardHints.paragraph
                        hint = "Additional vehicle facts here..."

                        content bind vehicle.prop(Vehicle.path.description).nullToBlank()
                    }
                }
            }, fields = listOf(
                Vehicle_description.optional()
            )
        ),
        Pricing(
            Strings.pricing, render = { vehicle, proceed ->
                card - col {
                    centered - col {
                        row {
                            gravity(Align.Start, Align.Center) - h3 { content = Strings.reserve2 }
                            expanding - space()
                            gravity(Align.End, Align.Center) - priceField(vehicle.prop(Vehicle.path.reserve))
                        }
                        text(Strings.yourReserveIsPrivateToYouAndCan)
                    }

                    val lanes = remember {
                        currentSession().auctionLane.query(
                            Query()
                        )()
                    }

                    space(4.0)

                    col {
                        ::shown {
                            vehicle().reserve?.let { it >= 1000 } == true
                        }
                        centered - row {
                            centered - important - checkbox {
                                checked bind remember {
                                    vehicle().submitted != null
                                }.withWrite { v ->
                                    vehicle.modify { it.copy(submitted = if (v) now() else null) }
                                }
                            }
                            centered - bold - text(Strings.submitThisVehicleToAnAuction)
                        }
                    }

                    space(4.0)

                    row {
                        ::shown {
                            val v = vehicle()
                            v.submitted != null
                        }
                        expanding - col {
                            fieldTheme - select {
                                bind(
                                    edits = remember {
                                        vehicle().auctionLane?.let { vehicleLaneId -> lanes().find { it._id == vehicleLaneId } }
                                    }.withWrite { a ->
                                        vehicle.modify {
                                            it.copy(
                                                auctionLane = a?._id
                                            )
                                        }
                                    },
                                    data = remember { lanes() + null },
                                ) { a ->
                                    if (a == null) Strings.chooseAuctionLater else Strings.auctionWithStartDate(a)
                                }
                            }
                        }
                    }
                }
            }, fields = listOf(
                FieldWithValidator(Vehicle_reserve) {
                    if (it == null) EditStatus.Empty
                    else if (it < 1000) EditStatus.Incomplete
                    else EditStatus.Complete
                },
                Vehicle_auctionLane.optional(),
                Vehicle_submitted.optional()
            )
        ),
        ;

        data class FieldWithValidator<V>(val field: SerializableProperty<Vehicle, V>, val status: (V) -> EditStatus) {
            fun status(vehicle: Vehicle) = field.get(vehicle).let(status)
        }

        fun ready(vehicle: Vehicle) = fields.minOf { it.status(vehicle) }
    }

    private val allEditedProps = Tab.values().flatMap { it.fields.map { it.field } }

    @QueryParameter
    val tab = Signal<Tab>(Tab.Images)

    val vehicle = Signal<Vehicle>(Vehicle(vin = ""))
    val originalVehicle = MutableRemember {
        currentSession().vehicle[vehicleId].awaitNotNull().also { vehicle.value = it }
    }

    val Tab.status get() = remember { ready(vehicle()) }

    override fun ViewWriter.render() = col {
        scrollsHorizontally - row {
            gap = 0.px
            expanding - space()
            for (t in Tab.values()) sizeConstraints(width = 9.rem) - unpadded - radioToggleButton {
                col {
                    space()
                    row {
                        gap = 0.px
                        if (t == Tab.values()
                                .first()
                        ) expanding - space() else centered - expanding - col { separator() }
                        centered - icon {
                            ::source label@{
                                t.status().icon
                            }
                        }
                        if (t == Tab.values()
                                .last()
                        ) expanding - space() else centered - expanding - col { separator() }
                    }
                    centered - text(t.title)
                    space()
                }
                checked bind tab.equalTo(t)
                reactiveScope {
                    if (tab() == t) scrollIntoView(Align.Center, Align.Center, true)
                }
            }
            expanding - space()
        }
        expanding - swapView {
            swapping(current = { tab() }, views = {
                pageWithMaxWidth(60.rem) {
                    scrolls - padded - it.render(this, vehicle) { proceed() }
                }
            })
        }
        gravity(
            Align.Center,
            Align.Center
        ) - row {
            val saveNeeded = remember {
                val a = originalVehicle()
                val b = vehicle()
                allEditedProps.any { it.get(a) != it.get(b) }
            }
            val readyToProceed = remember {
                val v = vehicle()
                tab().ready(v) == EditStatus.Complete
            }

            row {
                expanding - space()
                button {
                    ::shown { !flowMode() }
                    text("Cancel")
                    onClick {
                        pageNavigator.goBack()
                    }
                }
                important - button {
                    ::enabled {
                        if (flowMode()) readyToProceed() else saveNeeded()
                    }
                    text {
                        ::content {
                            if (flowMode()) {
                                if (saveNeeded()) "Save and Continue"
                                else "Continue"
                            } else {
                                if (saveNeeded()) Strings.save
                                else Strings.saved
                            }
                        }
                        content = "Save"
                    }
                    onClick {
                        proceed()
                    }
                }
            }
        }
    }

    suspend fun ViewWriter.proceed() {
        val v = vehicle()
        try {
            val changeClearsAutobids = originalVehicle.state.getOrNull()?.minorInfoHash != vehicle.value.minorInfoHash
            originalVehicle set (currentUserSession().vehicle.get(vehicleId).modify(modification {
                for (prop in allEditedProps) {
//                log.info("assigning prop ${prop.name}")
                    it.get(prop as SerializableProperty<Vehicle, Any?>).assign(prop.get(v))
                }
            })!!).let {
                if (changeClearsAutobids) it.copy(autobids = 0) else it
            }
            println("originalVehicle $originalVehicle")
            if (changeClearsAutobids) {
                currentUserSession().vehicleRelationship.localSignalUpdate(
                    matching = { it._id.vehicle == vehicleId },
                    modify = { it.copy(autobid = null) }
                )
            }
            vehicle set originalVehicle()
            log.info("setting vehicle")
        } catch (e: Exception) {
            log.info("caught error $e")
            alert(Strings.error, Strings.thereWasAnErrorSavingYourChanges)
            return
        }
        if (flowMode()) {
            val nextTab = Tab.values().getOrNull(tab().ordinal + 1)
            if (nextTab != null) {
                tab set nextTab
            } else {
                this.pageNavigator.replace(SellingCenterScreen().apply {
                    this.tab set if (v.submitted != null) SellingCenterScreen.SellingTab.Inventory else SellingCenterScreen.SellingTab.Draft
                    this.selectedLot set vehicleId
                })
            }
        } else {
            pageNavigator.goBack()
        }
    }
}


enum class EditStatus(val icon: Icon) { Empty(Icon.emptyCircle), Incomplete(Icon.emptyCircle), Complete(Icon.checkCircle) }

internal fun <T, V> MutableReactive<T>.prop(path: DataClassPath<T, V>): MutableReactive<V> =
    remember { this@prop().let { path.get(it) as V } }
        .withWrite { v -> this@prop.modify { path.set(it, v) } }

internal fun MutableReactive<String?>.nullToBlank() = remember { this@nullToBlank() ?: "" }
    .withWrite { v -> this@nullToBlank set (v.takeUnless { it.isBlank() }) }

internal fun MutableReactive<Short?>.toInt() = remember { this@toInt()?.toInt() }
    .withWrite { v -> this@toInt set (v?.toShort()) }

internal val tempImagePointers = HashMap<ServerFile, ImageLocal>()
internal fun ServerFile.toImage(): ImageSource = tempImagePointers[this] ?: ImageRemote(location)

@JsName("requiredServerFile")
@JvmName("requiredServerFile")
private inline fun SerializableProperty<Vehicle, ServerFile?>.required() =
    EditVehicleScreen.Tab.FieldWithValidator(this) { if (it == null) EditStatus.Empty else EditStatus.Complete }

@JsName("requiredBoolean")
@JvmName("requiredBoolean")
private inline fun SerializableProperty<Vehicle, Boolean>.required() =
    EditVehicleScreen.Tab.FieldWithValidator(this) { if (!it) EditStatus.Empty else EditStatus.Complete }

@JsName("requiredStringN")
@JvmName("requiredStringN")
private inline fun SerializableProperty<Vehicle, String?>.required() =
    EditVehicleScreen.Tab.FieldWithValidator(this) { if (it == null || it.isBlank()) EditStatus.Empty else EditStatus.Complete }

@JsName("requiredString")
@JvmName("requiredString")
private inline fun SerializableProperty<Vehicle, String>.required() =
    EditVehicleScreen.Tab.FieldWithValidator(this) { if (it.isBlank()) EditStatus.Empty else EditStatus.Complete }

@JsName("requiredPhotos")
@JvmName("requiredPhotos")
private inline fun SerializableProperty<Vehicle, List<VehiclePhoto>>.required() =
    EditVehicleScreen.Tab.FieldWithValidator(this) { if (it.isEmpty()) EditStatus.Empty else EditStatus.Complete }

@JsName("requiredMedia")
@JvmName("requiredMedia")
private inline fun SerializableProperty<Vehicle, List<VehicleMedia>>.required() =
    EditVehicleScreen.Tab.FieldWithValidator(this) { if (it.isEmpty()) EditStatus.Empty else EditStatus.Complete }

@JsName("requiredVN")
@JvmName("requiredVN")
private inline fun <V> SerializableProperty<Vehicle, V?>.required() =
    EditVehicleScreen.Tab.FieldWithValidator(this) { if (it == null) EditStatus.Empty else EditStatus.Complete }

@JsName("requiredV")
@JvmName("requiredV")
private inline fun <V> SerializableProperty<Vehicle, V>.optional() =
    EditVehicleScreen.Tab.FieldWithValidator(this) { EditStatus.Complete }